export default __webpack_public_path__ + "static/media/allStudents.362a24b0.svg";